import { render, staticRenderFns } from "./conf_modal.vue?vue&type=template&id=4850932a&scoped=true&"
import script from "./conf_modal.vue?vue&type=script&lang=js&"
export * from "./conf_modal.vue?vue&type=script&lang=js&"
import style0 from "./conf_modal.vue?vue&type=style&index=0&id=4850932a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850932a",
  null
  
)

export default component.exports